import React from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withDebouncedHandlers } from '../../../helpers/hocs/with-debounced-handlers';
import { isEmail } from '../../../helpers/validation/account';
import { setAccountData, setAccountError, checkEmail } from '../../../store/reducers/account/actions';
import { sendStatus } from '../../../store/reducers/status-data';
import { InputField as Input } from '../../../components/inputs/input';
import { InputButtonWithIcon as ButtonWithIcon } from '../../../components/buttons/button-with-icon';
import { AccountPage } from '../../../templates/account';
import { toHistoryArgs, withSearchParams } from '../../../helpers/navigation/routing';
import { withRedirectAfterComplete } from '../hocs/with-redirect-after-complete';
import { withUser } from '../components';

const Component = ({ value, error, isValid, handleChange, handleSubmit }) => {
  const {
    ACCOUNT: {
      SIGN_UP: {
        title,
        identifier,
        subheading,
        pageHeader,
        email: {
          label,
          inPageMessage,
          message,
          heading,
          body,
          legalFooter,
          buttons: { confirm, needToLogin }
        }
      }
    }
  } = window.CONFIG;

  return (
    <AccountPage
      title={title}
      subheading={subheading}
      category={identifier}
      inPageMessage={inPageMessage}
      message={message}
      heading={heading}
      body={body}
      legalFooter={legalFooter}
      onSubmit={handleSubmit}
      pageHeader={pageHeader}
    >
      <Input
        data-atid='sign-up-email-input'
        label={label}
        onChange={handleChange}
        value={value}
        type='email'
        error={error}
      />
      <ButtonWithIcon data-atid='sign-up-continue-button' buttonType='submit' disabled={!isValid}>
        {confirm}
      </ButtonWithIcon>
      {needToLogin.show && (
        <ButtonWithIcon type='minor' to={withSearchParams('/account/login')}>
          {needToLogin.label}
        </ButtonWithIcon>
      )}
    </AccountPage>
  );
};

const mapDispatchToProps = state => {
  const value = state.account.email;

  return {
    value: state.account.email,
    isValid: isEmail(value),
    error: state.account.checkingEmailAvailabilityError
  };
};

export const SignUpEmail = compose(
  withRedirectAfterComplete,
  withUser(),
  connect(mapDispatchToProps, { setAccountData, setAccountError, checkEmail, sendStatus }),
  withHandlers({
    handleChange:
      ({ setAccountData }) =>
      value =>
        setAccountData('email', value)
  }),
  withDebouncedHandlers({
    handleSubmit:
      ({ checkEmail, history }) =>
      () => {
        checkEmail('available', () => {
          history.push(toHistoryArgs(withSearchParams('/account/sign-up/password'), { completed: true }));
        });
      }
  }),
  lifecycle({
    componentDidMount() {
      const { setAccountError, sendStatus } = this.props;

      setAccountError('checkingEmailAvailabilityError', '');
      sendStatus('accountCreated', 'seen');
    }
  })
)(Component);
